/**
 * @generated SignedSource<<ba701f1636bbb4e47663382e6b8b49aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogPost_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsGuest">;
  readonly " $fragmentType": "BlogPost_User";
};
export type BlogPost_User$key = {
  readonly " $data"?: BlogPost_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPost_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPost_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsGuest"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4b6957d82f43c0f03494d299971a0e00";

export default node;
